import useUser from "../../../../core/hooks/use-user";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import useModal from "../../../../core/hooks/use-modal";
import { useState } from "react";
import FormPermisos from "../components/form-permisos";
import swal from "sweetalert";
import { sweetAl } from "../../../../core/helpers/message-helper";
import { activarPermiso, inactivarPermiso } from "../../services/permisos-service";

const DATOS_INICIALES_MODAL = {
    title: "Agregar Permiso",
    data: { permiso: {} },
};

const Permisos = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalPermisos = useModal(DATOS_INICIALES_MODAL);
    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("permisosCrear")) {
        tableButtons.push({
            titleAttr: "Agregar Permiso",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalPermisos.open(DATOS_INICIALES_MODAL);
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("permisosEditar")) {
        tableButtons.push({
            titleAttr: "Editar Permiso",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalPermisos.open({
                    title: "Editar Permiso",
                    data: { permiso: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("permisosInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar Permiso",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar este permiso?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado el permiso");
                        break;
                    case "eliminar": {
                        const resp = await inactivarPermiso(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar el permiso"
                            );
                        }

                        sweetAl.success(
                            "El permiso fue inactivado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("permisosActivar")) {
        tableButtons.push({
            titleAttr: "Activar Permiso",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar este grupo?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado el grupo");
                        break;
                    case "activar": {
                        const resp = await activarPermiso(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar el grupo"
                            );
                        }

                        sweetAl.success("El grupo fue activado correctamente");
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "permisos",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaPermisos",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/permisos`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de permisos"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "permission_name" },
            { data: "grupo" },
            { data: "name" },
            { data: "description" },
            { data: "status" },
            { data: "permission_group_id", visible: false },
        ],
        columnDefs: [
            {
                targets: 5,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Permisos
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table className="w-100 table table-hover" id="tablaPermisos">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Grupo</th>
                            <th>Codigo</th>
                            <th>Descripcion</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormPermisos modalState={modalPermisos} onSave={onSave} />
        </ContentWrapper>
    );
};

export default Permisos;
